import type { ActionBinding } from "./ActionBinding.type"
import type { InputActionType } from "./InputActionType"
import type { AnyInputBinding } from "./InputBinding/InputBindingUnion.type"

export default function createActionBinding (
  action: InputActionType,
  input: AnyInputBinding,
): ActionBinding {
  return {
    action,
    input,
  }
}